import fortify from "../../../img/fortify.png";
import "./Projectleftimage.css";

const Projectimage = () => {
  return <img src={fortify} className="photossss  reveal fade-left" />;
};

export default Projectimage;
